import React from "react";
import { Props } from "./type";
import styles from "./styles.scss";
import { Skeleton } from "@common/skeleton";

function Loader(props: Props) {
  return (
    <div className={styles.loader}>
      <Skeleton className={styles.title} />
      <div className={styles.projects}>
        <Skeleton className={styles.item} />
        <Skeleton className={styles.item} />
        <Skeleton className={styles.item} />
        <Skeleton className={styles.item} />
        <Skeleton className={styles.item} />
        <Skeleton className={styles.item} />
      </div>
      <div className={styles.legend}>
        <div className={styles.row}>
          <Skeleton className={styles.pellet} />
          <Skeleton className={styles.item} />
        </div>
        <div className={styles.row}>
          <Skeleton className={styles.pellet} />
          <Skeleton className={styles.item} />
        </div>
        <div className={styles.row}>
          <Skeleton className={styles.pellet} />
          <Skeleton className={styles.item} />
        </div>
      </div>
      <div className={styles.footer} />
    </div>
  );
}

export { Loader };
